import { Layout, Space, Typography } from 'antd';

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

export default function Footer() {
  return (
    <AntFooter className="flex justify-between items-center px-0  bg-transparent flex-wrap gap-2">
      <Text type="secondary" className="text-xs">
        © 2026GYM VERTICAL Panel. All rights reserved.
      </Text>
    </AntFooter>
  );
}
